
import React, { useState } from 'react';
import logo from './Assets/lumeylines.png';
function HowMuch() {
    // track whether the "Other" button is clicked
    const [isOther, setIsOther] = useState(false);
    // only show the text input if the "Other" button is clicked
    const showOther = isOther ? 'block' : 'none';
    // Track the current value of the text input or the selected option
    const [amount, setAmount] = useState(0);
    // Send the amount to the /payment page when the "Pay" button is clicked, making sure that the amount is not over $500 and is not less than $1



    return (
      <div className="HowMuch">
        <img src={logo} alt='Logo' id='logo'></img>
        <h1>How much?</h1>
        <p style={{textAlign: 'center'}}>How much would you like to donate?</p>
       {/* Show a set of options and an "Other" button. The options should be $5, $10, and $20 */}
        <div className="AmountOptions">
        <button className="option" onClick={() => {setIsOther(false); setAmount(5)}}>$5</button>
            <button className="option" onClick={() => {setIsOther(false); setAmount(10)}}>$10</button>
            <button className="option" onClick={() => {setIsOther(false); setAmount(20)}}>$20</button>
            <button className="option" onClick={() => {setIsOther(true); setAmount(0)}}>Other</button>

        </div>
        {/* Show a text input that is only visible when the "Other" button is clicked and disappears if other is clicked off of. It should have a minimum input requirement of one dollar */}
        <div id="AmountOther">
        <input type="number" min="1" max="500" id="otherInput" placeholder="Enter amount (Minimum $1)" style={{display: showOther}} onChange={(e) => {setAmount(e.target.value)}}/>


        </div>

        <div className="Amount__button" >
        {/* The "Pay" button should be disabled if the amount is less than $1 or greater than $500 */}
        <button className="PayButton" disabled={amount < 1 || amount > 500} onClick={() => {window.location.href = `/payment?amount=${amount}`}}>Pay ${amount}</button>


        </div>
      </div>
    );
  }
  
  export default HowMuch;